<template>
  <div class="page-container">
    <div class="header-box">
      <el-carousel
        :autoplay="true"
        :interval="4000"
        height="25.625rem"
        indicator-position="none"
        data-aos="zoom-in"
        data-aos-duration="1000"
        data-aos-once="true"
      >
        <el-carousel-item
          v-for="(banner, banIndex) in bannerList"
          :key="banIndex"
        >
          <img class="banner-img" :src="banner.litpic" :alt="banner.title" />
          <div class="text-box">
            <!-- <p class="title">{{ banner.title }}</p>
            <p class="sub-title">
              {{ banner.subtitle }}
            </p> -->
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="introduce-box">
      <p
        class="chunk-name"
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-once="true"
      >
        {{ $t("homeView.title1") }}
      </p>
      <div class="flex">
        <div class="content">
          <p data-aos="fade-up" data-aos-duration="1000" data-aos-once="true">
            {{ $t("homeView.PlatformDescription") }}
          </p>
          <div
            class="link-box"
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-once="true"
          >
            <div class="link-item" @click="linkTo('/kjds', 21)">
              <div class="link-icon">
                <img src="@/assets/images/home/link-icon1.png" alt="" />
              </div>
              <div>{{ $t("homeView.Kjds") }}</div>
            </div>
            <div class="link-item" @click="linkTo('/kjds', 21)">
              <div class="link-icon">
                <img src="@/assets/images/home/link-icon2.png" alt="" />
              </div>
              <div>{{ $t("homeView.Kjrmb") }}</div>
            </div>
            <div class="link-item" @click="linkTo('/wmzh', 15)">
              <div class="link-icon">
                <img src="@/assets/images/home/link-icon3.png" alt="" />
              </div>
              <div>{{ $t("homeView.Wmzh") }}</div>
            </div>
          </div>
        </div>
        <div
          class="introduce-bg"
          data-aos="fade-left"
          data-aos-duration="1000"
          data-aos-once="true"
        >
          <img :src="kzfUrl" mode="scaleToFill" alt="跨境电商转型升级" />
        </div>
      </div>
      <div class="ptfw-bg2">
        <img class="ptimg" :src="ptfwUrl" alt="" />
      </div>
      <div class="platform-service">
        <div class="ptfw-box">
          <div
            class="ptfw-item"
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-once="true"
            @click="linkWmzh('/wmzh',15,1)"
          >
            <div><img src="@/assets/images/home/ptbg.png" alt="" /></div>
            <div>{{ $t("homeView.ptbg") }}</div>
          </div>
          <div
            class="ptfw-item"
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-once="true"
            @click="linkWmzh('/wmzh',15,1)"
          >
            <div><img src="@/assets/images/home/ptbj.png" alt="" /></div>
            <div>{{ $t("homeView.ptbj") }}</div>
          </div>
          <div
            class="ptfw-item"
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-once="true"
            @click="linkWmzh('/wmzh',15,2)"
          >
            <div><img src="@/assets/images/home/ptsjh.png" alt="" /></div>
            <div>{{ $t("homeView.ptsjh") }}</div>
          </div>
          <div
            class="ptfw-item"
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-once="true"
            @click="linkWmzh('/wmzh',15,3)"
          >
            <div><img src="@/assets/images/home/ptts.png" alt="" /></div>
            <div>{{ $t("homeView.ptbsts") }}</div>
          </div>
          <div
            class="ptfw-item"
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-once="true"
            @click="linkWmzh('/wmzh',15,4)"
          >
            <div><img src="@/assets/images/home/pthwc.png" alt="" /></div>
            <div>{{ $t("homeView.pthwc") }}</div>
          </div>
          <div
            class="ptfw-item"
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-once="true"
            @click="linkWmzh('/wmzh',15,5)"
          >
            <div><img src="@/assets/images/home/ptbx.png" alt="" /></div>
            <div>{{ $t("homeView.ptbx") }}</div>
          </div>
          <div
            class="ptfw-item"
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-once="true"
            @click="linkWmzh('/wmzh',15,4)"
          >
            <div><img src="@/assets/images/home/ptwl.png" alt="" /></div>
            <div>{{ $t("homeView.ptwl") }}</div>
          </div>
          <div
            class="ptfw-item"
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-once="true"
            @click="linkTo('/jrfw',16)"
          >
            <div><img src="@/assets/images/home/ptjr.png" alt="" /></div>
            <div>{{ $t("homeView.ptjr") }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 金融服务 -->
    <div
      class="ability-box animated fadeIn"
      data-aos="ease-in"
      data-aos-duration="1000"
    >
      <p
        class="chunk-name"
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-once="true"
      >
        {{ $t("homeView.title2") }}
      </p>
      <div
        class="ability-card-box flexcenter"
        data-aos="fade-right"
        data-aos-duration="1000"
        data-aos-once="true"
      >
        <div
          class="ability-card flexcolumn"
          v-for="(item, index) in abilityList"
          :key="index"
          :class="{ 'is-hovered': isHovered[index].value }"
          @mouseenter="handleMouseEnter(index)"
          @mouseleave="handleMouseLeave(index)"
          :style="{ backgroundImage: 'url(' + item.thumb + ')' }"
          @click="linkTo('/jrfw', 16)"
        >
          <div class="jrimg-box">
            <div class="jrimg-title-box">
              <div class="jrimg-title">
                {{ $t(`${"homeView." + item.title + index}`) }}
              </div>
              <div class="jrimg-desc"></div>
            </div>
          </div>
          <div class="ability-title-box"></div>
          <div class="ability-desc-box">
            <p class="ability-title fwBold mb18">
              {{ $t(`${"homeView." + item.title + index}`) }}
            </p>
            <p class="ability-desc">
              {{ $t(`${"homeView." + item.subtitle + index}`) }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- 产品展示 -->
    <div class="goods-box">
      <p
        class="chunk-name"
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-once="true"
      >
        {{ $t("homeView.title3") }}
      </p>
      <p
        class="more-name"
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-once="true"
      >
       <a href="https://www.rmbsilkroad.com/" target="_blank">{{ $t("homeView.more") }}</a>
      </p>
      <!-- <swiper :options="swiperOptions" class="swiper">
        <swiper-slide v-for="(item, index) in goodsList" :key="index">
          <img :src="item.litpic" />
          <p class="medium">{{ item.title }}</p>
        </swiper-slide>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper> -->
      <div class="goods-box-list">
        <div
          class="goods-item"
          v-for="(item, index) in goodsList"
          :key="index"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-once="true"
        >
          <img :src="item.litpic" />
          <p class="medium">{{ item.title }}</p>
        </div>
      </div>
    </div>

    <!-- 新闻资讯 -->
    <div class="news">
      <p
        class="chunk-name"
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-once="true"
      >
        {{ $t("homeView.title4") }}
      </p>
      <div class="news-box flexStart animated fadeIn">
        <div
          class="left-panel"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-once="true"
        >
          <div
            class="news-content flex_between txt-left"
            v-for="item in newsList"
            :key="item.aid"
            @click="toDetails(item.aid)"
          >
            <p class="news-title oneHidden">
              {{ item.title }}
            </p>
            <span>{{ item.add_time_format }}</span>
          </div>
        </div>
        <div
          class="right-panel"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-once="true"
        >
          <el-carousel
            class="banner-box"
            :autoplay="true"
            :interval="3000"
            height="14.125rem"
            indicator-position="none"
          >
            <el-carousel-item v-for="item in newsBannerList" :key="item.aid">
              <img
                class="new-img"
                :src="item.litpic"
                :alt="item.title"
                @click="toDetails(item.aid)"
              />
              <p class="text oneHidden">{{ item.title }}</p>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <div class="website-box animated fadeI">
      
      <div class="website-cont flexwrap">
        <p
        class="chunk-name"
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-once="true"
        style="width: 100%;"
      >
        {{ $t("homeView.title5") }}
      </p>
        <div
          class="website-title"
          v-for="(item, index) in websiteList"
          :key="index"
          @click="toWebsite(item)"
        >
          <div class="title-text">{{ item.title }}</div>
        </div>
      </div>
    </div>
    <!-- <div class="back-top">
      <el-backtop target=".page-container"></el-backtop>
    </div> -->
    <!-- <BackTop targetDom=".page-container"></BackTop> -->
  </div>
</template>
p
<script>
import Search from "@/components/Search";
// import Layout from "@/views/layout/index";
import NavMenu from "../layout/Navmenu";
import Header from "../layout/Header";
import Footer from "../layout/Footer";
import BackTop from "../layout/BackTop";

export default {
  props: {},
  data() {
    return {
      bannerList: [], // banner list
      searchVal: "",
      activeNewsName: "",
      // kzfUrl: require("../../assets/images/home/ptjs.gif"),
      kzfUrl: require("../../assets/images/home/VCG211371069012.png"),
      
      abilityList: [
        {
          title: "jrfw",
          subtitle: "jrfwdesc",
          thumb: require("../../assets/images/C1.png"),
          pagepath: "/hall",
          params: "",
          type: "2",
        },
        {
          title: "jrfw",
          subtitle: "jrfwdesc",
          thumb: require("../../assets/images/C2.png"),
          pagepath: "/hall",
          params: "",
          type: "2",
        },
        {
          title: "jrfw",
          subtitle: "jrfwdesc",
          thumb: require("../../assets/images/C3.png"),
          pagepath: "/hall",
          params: "cate_id=21",
          type: "2",
        },
        {
          title: "jrfw",
          subtitle: "jrfwdesc",
          thumb: require("../../assets/images/C4.png"),
          pagepath: "/hall",
          params: "",
          type: "2",
        },
        {
          title: "jrfw",
          subtitle: "jrfwdesc",
          thumb: require("../../assets/images/C5.png"),
          pagepath: "/hall",
          params: "",
          type: "2",
        },
      ], //能力列表
      isHovered: [
        { value: true },
        { value: false },
        { value: false },
        { value: false },
        { value: false },
      ],
      websiteList: [], //网站列表
      newsList: [], //新闻列表
      newsBannerList: [], //新闻banner
      // lang: "",
      ptfwUrl: require("@/assets/images/home/ptfw2.jpg"),
      goodsList: [],
      swiperOptions: {
        // 你可以添加更多的swiper选项
        direction: "horizontal",
        initialSlide: 0,
        observeParents: true,
        observer: true,
        slidesPerView: "auto", // 显示几个
        centeredSlides: false, // 居中显示
        spaceBetween: 0,
        loop: true,
        loopedSlides: 10,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
        },
        // pagination: {
        //   el: ".swiper-pagination",
        //   clickable: true,
        // },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  // computed: {},
  computed: {
    lang: {
      get() {
        return this.$store.state.app.language;
      },
      set(lang) {
        this.$i18n.locale = lang;
        this.$store.dispatch("setLanguage", lang);
      },
    },
  },
  created() {
    // this.lang = this.$store.state.app.language;
    this.getHomeData();
    this.getFriendLink();
    this.getArticleData();
    this.getArticleImgs();
    this.getGoodsList();
  },
  mounted() {},
  watch: {
    lang(newVal, oldVal) {
      this.getHomeData();
      this.getFriendLink();
      this.getGoodsList();
      this.getArticleData();
      this.getArticleImgs();
    },
  },
  methods: {
    //获取首页部分数据
    async getHomeData() {
      try {
        const res = await this.$http.fetchGet("/Index/adv", {
          pid: 1,
          row: 5,
          lang: this.lang,
        });
        if (res.code == 1) {
          this.bannerList = res.data;
          // this.abilityList = res.data.advs[2];
        }
      } catch (error) {
        console.error("请求失败:", error);
      }
    },
    async getGoodsList() {
      try {
        const res = await this.$http.fetchPost("/Product/index", {
          lang: this.lang,
          is_rem: 1,
          page: 1,
          limit: 8,
        });
        if (res.code == 1) {
          this.goodsList = res.data.list;
          // console.log(this.goodsList);
        }
      } catch (error) {
        console.error("请求失败:", error);
      }
    },
    //获取友情链接
    async getFriendLink() {
      try {
        const res = await this.$http.fetchGet("/Index/links", {
          lang: this.lang,
        });
        if (res.code == 1) {
          this.websiteList = res.data;
        }
      } catch (error) {
        console.error("请求失败:", error);
      }
    },
    //获取推荐文章
    async getArticleData() {
      try {
        const res = await this.$http.fetchPost("/Article/index", {
          is_rem: 1,
          lang: this.lang,
          page: 1,
          limit: 6,
        });
        if (res.code == 1) {
          this.newsList = res.data.list;
        }
      } catch (error) {
        console.error("请求失败:", error);
      }
    },
    async getArticleImgs() {
      try {
        const res = await this.$http.fetchPost("/Article/images", {
          lang: this.lang,
        });
        if (res.code == 1) {
          this.newsBannerList = res.data.list;
        }
      } catch (error) {
        console.error("请求失败:", error);
      }
    },
    //搜索关键字
    searchQuery(val) {
      console.log(val);
    },
    //页面滑动是否触发吸顶
    handleScroll() {
      const scrollTop = this.$refs.scrollContainer.scrollTop;
      const threshold = this.originalTop;
      if (scrollTop >= threshold) {
        this.isFixed = true;
      } else {
        this.isFixed = false;
      }
    },
    // 解析参数字符串的方法
    parseParamsString(paramsString) {
      if (!paramsString) return {};

      const params = {};
      const paramsArray = paramsString.split("&");

      paramsArray.forEach((param) => {
        const [key, value] = param.split("=");
        params[key] = decodeURIComponent(value);
      });

      return params;
    },
    // 跳转到友情链接
    toWebsite(val) {
      window.open(val.url, "_blank");
    },
    //跳转到跨境讲堂
    toHall(val, index) {
      const params = this.parseParamsString(val.params);
      this.$router.push({
        path: "/hall",
        query: {
          name: val.title,
          index: index,
          ...params,
        },
      });
    },
    //去登陆
    toLogin() {
      this.$router.push("/login");
    },
    //去注册
    toRegister() {
      this.$router.push("/register");
    },
    //跳转到资讯详情
    toDetails(id) {
      this.$router.push({
        path: "/zxdetails",
        query: {
          id: id,
        },
      });
    },
    linkTo(path, navId) {
      this.$store.dispatch("SET_CurrentNavIndex", navId);
      this.$router.push({
        path: path,
      });
    },
    linkWmzh(path,navId,tabName) {
      this.$store.dispatch("SET_CurrentNavIndex", navId);
      this.$router.push({
        path: path,
        query: {
          tabName: tabName
        }
      });
    },
    //
    handleNewsClick(tab, event) {
      console.log(tab, event);
      this.activeNewsName = tab.name;
    },
    handleMouseEnter(index) {
      for (let i = 0; i < this.isHovered.length; i++) {
        if (i === index) {
          this.isHovered[i].value = true;
        } else {
          this.isHovered[i].value = false;
        }
      }
    },
    handleMouseLeave(index) {
      // this.isHovered[index].value = false;
    },
  },
  components: {
    Search,
    Header,
    NavMenu,
    Footer,
    BackTop,
  },
};
</script>

<style scoped lang="scss">
@keyframes zoomIn {
  0% {
    width: 100%; /* 动画开始的宽度 */
  }
  100% {
    width: 110%; /* 动画结束的宽度 */
  }
}
.page-container {
  // height: 100vh;
  overflow-x: hidden;
  .header-box {
    width: 100%;
    // padding: 1.25rem 22.5rem;
    height: 25.625rem;
    // background: url("https://zjkzf.oss-cn-hangzhou.aliyuncs.com/website/images/banner.jpg")
    //   no-repeat center;
    background-size: 100%;
    position: relative;
    .banner-img {
      width: 100px; /* 初始宽度 */
      height: auto;
      transition: width 10s ease-in-out; /* 平滑的过渡效果 */
      animation: zoomIn 10s infinite alternate; /* 应用动画 */
    }
    .text-box {
      width: 100%;
      position: absolute;
      top: 13.5rem;
      left: 50%;
      transform: translateX(-50%);
      text-align: center;
      .title {
        font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
        font-size: 4.125rem;
        color: #ffffff;
        text-shadow: 0px 0px 20px rgba(12, 23, 97, 0.88);
      }
      .sub-title {
        width: fit-content;
        font-weight: 300;
        font-size: 2.0625rem;
        color: #ffffff;
        text-align: center;
        text-shadow: 0px 0px 20px rgba(12, 23, 97, 0.88);
        background: rgba(46, 46, 46, 0.8);
        border-radius: 6px;
        padding: 0.875rem 2.5rem;
        margin: 0 auto;
        margin-top: 1rem;
      }
    }
  }

  .introduce-box {
    width: 100rem;
    margin: 0 auto;
    margin-top: 3.125rem;
    text-align: left;
    position: relative;
    margin-bottom: 3.125rem;
    background-color: #ffffff;
    padding: 1.25rem;
    box-shadow: 0px 3px 6px 1px rgba(38, 74, 124, 0.1);
    // padding-bottom: 4.6875rem;
    .ptfw-bg2 {
      width: 97.5rem;
      height: 9.75rem;
      margin-bottom: 2.25rem;
      img {
        width: 100%;
      }
    }
    .content {
      width: 56.25rem;
      // height: 22.5rem;
      font-weight: 400;
      font-size: 1.25rem; //cs20px
      color: #2a2a2a;
      line-height: 2rem;
      margin-bottom: 2.25rem;
      p {
        text-indent: 2rem;
        margin-bottom: 2.5rem;
      }
      .link-box {
        display: flex;
        // align-items: center;
        .link-item {
          width: 17.5rem;
          height: 10rem;
          // line-height: 8.625rem;
          background: #ffffff;
          box-shadow: 0px 3px 6px 1px rgba(38, 74, 124, 0.1);
          border: 1px solid #f9f2eb;
          margin-right: 0.9375rem;
          font-weight: 400;
          font-size: 1.5rem;
          color: #2a2a2a;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          text-align: center;
          // padding: 1.625rem 0;
          cursor: pointer;
          // &:hover {
          //   background: #B9732F;
          // }
          &:last-child {
            margin-right: 0;
          }
          .link-icon {
            width: 4.6875rem;
            height: 4.6875rem;
            margin-bottom: 0.625rem;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
    .introduce-bg {
      width: 43.75rem;
      height: 22.5rem;
      text-align: center;
      img {
        width: 40rem;
        height: 22.5rem;
      }
    }
    .platform-service {
      display: flex;
      margin-bottom: 3.125rem;
      .ptfw-box {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
        .ptfw-item {
          width: 23.9375rem;
          height: 9.75rem;
          // line-height: 2.625rem;
          box-shadow: 0px 3px 6px 1px rgba(174, 185, 209, 0.16);
          text-align: center;
          font-size: 1.5rem;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          img {
            width: 4.6875rem;
            height: 4.6875rem;
            vertical-align: middle;
          }
        }
      }
    }
  }
  .ability-box {
    width: 100rem;
    height: 41.6875rem;
    margin: 0 auto;
    background-color: #ffffff;
    padding: 1.25rem;
    box-shadow: 0px 3px 6px 1px rgba(38, 74, 124, 0.1);
    margin-bottom: 3.125rem;
    .ability-card-box {
      width: 97.5rem;
      height: 34.5rem;
      overflow: hidden;
      cursor: pointer;
      .ability-card {
        width: 18.125rem;
        height: 34.5rem;
        box-sizing: border-box;
        text-align: left;
        position: relative;
        overflow: hidden;
        -webkit-transition: all 0.3s ease;
        -o-transition: all 0.3s ease;
        transition: all 0.3s ease;
        background-size: cover;
        background-repeat: no-repeat;
        &.is-hovered {
          width: 25rem;
          .ability-title-box {
            display: block;
            .ability-desc {
              text-align: left;
            }
          }
          .ability-desc-box {
            display: block;
          }
        }
        .ability-title-box {
          display: none;
          width: 25rem;
          height: 34.5rem;
          background-color: #1390d8;
          position: absolute;
          z-index: 2;
          left: 0;
          top: 0;
          padding: 80px 50px;
          font-size: 1.5rem;
          color: #fff;
          font-family: "microsoft yahei";
          line-height: 30px;
          text-align: center;
          box-sizing: border-box;
          opacity: 0.7;
        }
        .ability-desc-box {
          display: none;
          width: 25rem;
          height: 34.5rem;
          padding: 8rem 4rem 8rem 2.5625rem;
          position: absolute;
          z-index: 3;
          left: 0;
          top: 0;
          .ability-title {
            color: #fff;
            transition: color 0.3s ease, transform 0.3s ease;
            text-align: left;
            font-size: 1.5rem;
          }
          .ability-desc {
            color: #fff;
            transition: color 0.3s ease, transform 0.3s ease;
            text-align: left;
            font-size: 1.25rem; //cs20px
          }
        }
        .jrimg-box {
          width: 25rem;
          height: 34.5rem;
          position: relative;
          img {
            width: 25rem;
            height: 34.5rem;
            position: absolute;
            left: 0;
            top: 0;
            z-index: 1;
          }
          .jrimg-title-box {
            position: absolute;
            bottom: 6.25rem;
            left: 0;
            z-index: 2;
            text-align: center;
            width: 25rem;
            color: #ffffff;
            font-size: 2rem;
            font-weight: bold;
            .jrimg-desc {
              width: 2.5rem;
              height: 0.375rem;
              background-color: #ffffff;
              position: absolute;
              left: 50%;
              margin-left: -20px;
            }
          }
        }
      }
    }
  }
  .website-box {
    width: 100%;
    background: rgba(109, 175, 254, 0.05);
    min-height: 7.375rem;
    .website-cont {
      width: 100rem;
      margin: 0 auto;
      padding: 1.5625rem 0;
      .website-title {
        font-weight: 400;
        font-size: 1.25rem; //cs20px
        color: #2a2a2a;
        text-align: left;
        height: 2rem; /* 设置元素高度 */
        line-height: 2rem;
        margin-right: 3.75rem;
        &:hover {
          // font-weight: bold;
          color: #1390d8;
          cursor: pointer;
        }
      }
    }
  }
  .news {
    width: 100rem;
    margin: 0 auto;
    background-color: #ffffff;
    padding: 1.25rem;
    box-shadow: 0px 3px 6px 1px rgba(38, 74, 124, 0.1);
    margin-bottom: 3.125rem;
    .news-box {
      position: relative;
      .left-panel {
        flex: 1;
        width: 30.3125rem;
        .news-content {
          font-weight: 400;
          font-size: 1.25rem; //cs20px
          line-height: 1.5rem;
          color: #2a2a2a;
          position: relative;
          padding-left: 0.75rem;
          margin-bottom: 1.25rem;
          cursor: pointer;
          &:hover {
            cursor: pointer;
            color: #1390d8;
            &::before {
              background: #1390d8;
            }
          }
          .news-title {
            flex: 1;
            margin-right: 5.875rem;
          }
          &:last-child {
            margin-bottom: 0;
          }
          &::before {
            content: "";
            width: 0.25rem;
            height: 0.25rem;
            background: #2a2a2a;
            border-radius: 50%;
            position: absolute;
            left: 0;
            top: calc(50% - 0.125rem);
          }
        }
      }
      .right-panel {
        width: 31.25rem;
        height: 14.125rem;
        margin-left: 4.6875rem;
        position: relative;
        .banner-box {
          width: 25rem;
          height: 18.75rem;
          .new-img {
            width: 25rem;
            height: 18.75rem;
            cursor: pointer;
            // position: relative;
          }
          .text {
            width: 100%;
            position: absolute;
            left: 1.25rem;
            bottom: 0.8125rem;
            text-align: left;
            padding: 0.8125rem 1.25rem;
            font-weight: 400;
            font-size: 1.25rem; //cs20px
            color: #ffffff;
          }
        }
      }
    }
  }
  .chunk-name {
    text-align: left;
    font-weight: bold;
    font-size: 2rem;
    color: #2a2a2a;
    margin-bottom: 1.875rem;
  }
  .back-top {
    position: fixed;
    right: 2.5rem;
    bottom: 2.5rem;
    z-index: 999;
    display: flex;
    align-items: center;
    width: 3.75rem;
    height: 3.75rem;
    // background: #fff;
  }
  .goods-box {
    width: 100rem;
    margin: 0 auto;
    height: 49.125rem;
    padding: 1.25rem;
    margin-bottom: 3.125rem;
    background-image: url("../../assets/images/home/spzs.png");
    background-size: 100% 100%;
    position: relative;
    .more-name {
      position: absolute;
      right: 2rem;
      top: 1.25rem;
      font-size: 2rem;
      font-weight: bold;
      color: #aaa;
      vertical-align: middle;
      cursor: pointer;
    }
    .goods-box-list {
      width: 67.875rem;
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      position: absolute;
      top: 6.25rem;
      right: 8.5625rem;
      .goods-item {
        width: 16.5rem;
        height: 18.625rem;
        position: relative;
        margin-right: 0.625rem;
        margin-bottom: 1rem;
        &:nth-child(4) {
          margin-right: 0;
        }
        &:nth-child(8) {
          margin-right: 0;
        }
        img {
          width: 16.5rem;
          height: 16.5rem;
          //height: 100%
        }
        .medium {
          // position: absolute;
          // bottom: 1.625rem;
          // width: 100%;
          margin-top: .625rem;
          text-align: center;
          font-size: 1.25rem; //cs20px
          line-height: 1.5rem;
        }
      }
    }
    // .swiper-container {
    //   height: 21rem;
    //   .swiper-slide {
    //     width: 16.25rem;
    //     height: 16.25rem;
    //     text-align: center;
    //     img {
    //       width: 16.25rem;
    //       height: 16.25rem;
    //     }
    //   }
    //   .swiper-button-prev {
    //     top: 7.0625rem;
    //     border: 1px solid #d4d4d4;
    //     width: 2.5rem;
    //     height: 2.5rem;
    //     border-radius: 50%;
    //     color: #ffffff;
    //     background-color: #d4d4d4;
    //     &::after {
    //       // content: "\e6d4";
    //       font-size: 1.25rem;
    //       line-height: 1.25rem;
    //     }
    //     &:hover {
    //       background-color: #333;
    //     }
    //   }
    //   .swiper-button-next {
    //     top: 7.0625rem;
    //     border: 1px solid #d4d4d4;
    //     width: 2.5rem;
    //     height: 2.5rem;
    //     border-radius: 50%;
    //     color: #ffffff;
    //     background-color: #d4d4d4;
    //     &::after {
    //       // content: "\e6d4";
    //       font-size: 1.25rem;
    //       line-height: 1.25rem;
    //     }
    //     &:hover {
    //       background-color: #333;
    //     }
    //   }
    // }
  }
}
</style>
<style lang="scss">
.news-box {
  .left-panel {
    .el-tabs__header {
      margin: 0 0 1.75rem;
    }
    .el-tabs__item {
      padding: 0 1.875rem;
      font-weight: bold;
      font-size: 1.25rem; //cs20px
      color: #2a2a2a;
      &:hover {
        color: #2a2a2a !important;
      }
    }
    .is-active {
      color: #2a2a2a !important;
      font-weight: bold !important;
      font-size: 1.5rem !important;
      // background: #2081ff !important;
    }
    .el-tabs__nav-wrap::after {
      background: none !important;
    }
    .el-tabs__active-bar {
      background: none !important;
    }
  }
}
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.5s;
}
.slide-enter, .slide-leave-to /* .slide-leave-active in <2.1.8 */ {
  transform: translateX(-100%);
}
</style>
